import { FC, useEffect, useState } from 'react';
import { Button, Card, Col, Progress, Row } from 'antd';
import { TbArrowRight, TbArrowUpRight, TbInfoCircle } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { useBilling } from '@/hooks/useBilling';
import { BaseSkeleton } from '@/shared/components/skeletons';

const CardSeatMeter: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const { token } = useAntDesignTheme();
    const { activeWorkspaceSeats, progressMeterValue, totalWorkspaceSeats, billingInformationLoading } = useBilling();

    const navigate = useNavigate();

    return (
        <>
            {activeWorkspaceSeats !== 0 && totalWorkspaceSeats !== 0 && !billingInformationLoading ? (
                <Card
                    style={{ marginTop: '1rem', borderRadius: token.borderRadius, width: '100%' }}
                    styles={{ body: { padding: '1rem 1.25rem' } }}
                >
                    <Row wrap={false}>
                        <Col flex='auto'>
                            <div style={{ fontWeight: 500, marginBottom: '0.25rem' }}>Seats</div>
                            <small>
                                {activeWorkspaceSeats} active seats
                                <span style={{ color: token.colorTextTertiary }}>
                                    {' '}
                                    / {totalWorkspaceSeats} seats in plan
                                </span>
                            </small>
                        </Col>
                        <Col flex='none'>
                            <Button
                                size='small'
                                type='dashed'
                                onClick={() => navigate('/settings/workspace/permissions')}
                            >
                                Manage Members{' '}
                                <TbArrowRight style={{ verticalAlign: '-0.175rem', marginLeft: '0.25rem' }} />
                            </Button>
                        </Col>
                    </Row>
                    <Progress
                        percent={progressMeterValue}
                        showInfo={false}
                        size='small'
                        success={{ strokeColor: token.blue6 }}
                        strokeColor={token.blue6}
                    />
                    <div style={{ marginTop: '0.25rem' }}>
                        <small>
                            <span style={{ color: token.colorTextTertiary }}>
                                <TbInfoCircle style={{ verticalAlign: '-0.1rem', marginRight: '0.25rem' }} />
                                Visit
                            </span>{' '}
                            <a href='http://' target='_blank' rel='noopener noreferrer'>
                                our docs
                                <TbArrowUpRight style={{ verticalAlign: '-0.15rem', marginLeft: '0.1rem' }} />
                            </a>{' '}
                            <span style={{ color: token.colorTextTertiary }}>to learn more about billing.</span>
                        </small>
                    </div>
                </Card>
            ) : (
                <Card
                    style={{ borderRadius: token.borderRadius, width: '100%' }}
                    styles={{ body: { padding: '1rem 1.25rem' } }}
                >
                    <BaseSkeleton title paragraph={{ rows: 1 }} style={{ margin: '0.25rem 0' }} />
                </Card>
            )}
        </>
    );
};

export default CardSeatMeter;
